(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-product-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.floating-product-video').forEach(function (el) {
  var trigger = parseInt(el.dataset.scrollTrigger || '400', 10);
  var video = el.querySelector('.floating-product-video__media');
  var closeBtn = el.querySelector('.floating-product-video__close');
  var soundBtn = el.querySelector('.floating-product-video__sound');
  var key = 'fpv-dismissed-' + el.id;
  var dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (e) {}
  var shown = false;
  var loaded = false;
  var ticking = false;

  // Video only downloads the first time the widget actually appears
  function loadOnce() {
    if (loaded) return;
    if (video.dataset.poster) { video.poster = video.dataset.poster; }
    video.src = video.dataset.src;
    video.load();
    loaded = true;
  }

  function check() {
    ticking = false;
    if (dismissed) return;
    if (window.pageYOffset > trigger) {
      if (!shown) {
        loadOnce();
        el.classList.add('is-visible');
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
        shown = true;
      }
    } else if (shown) {
      el.classList.remove('is-visible');
      video.pause();
      shown = false;
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(check);
      ticking = true;
    }
  }

  closeBtn.addEventListener('click', function () {
    el.classList.remove('is-visible');
    video.pause();
    dismissed = true;
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
    window.removeEventListener('scroll', onScroll);
  });

  soundBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    soundBtn.textContent = video.muted ? '🔇' : '🔊';
    if (!video.muted) { video.play().catch(function () {}); }
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  check();
});

  } catch(e) { console.error(e); }
})();
})();
